(function ($) {
    let likedPostsIdsStorage = JSON.parse(localStorage.getItem('likedPostsIds'));
    let likedPostsIds = likedPostsIdsStorage == null ? [] : likedPostsIdsStorage;
    let ajaxRunning = false;
    let ajaxRunningPostId = false;
    let requestCounter = 0;

	$.fn.frLikeButton = function () {
        
        /**
         * Update sessionStorage object
         */
        const updateSessionStorage = () => {
            localStorage.setItem('likedPostsIds', JSON.stringify(likedPostsIds));
        }

        /**
         * Add post id of liked post to likedPostsIds array
         */
        const addLike = (post_id) => {
            if(Array.isArray(likedPostsIds) && !likedPostsIds.includes(post_id)) likedPostsIds.push(post_id);
        }

        /**
         * Remove post id of disliked post from likedPostsIds array
         */
        const removeLike = (post_id) => {
            if(Array.isArray(likedPostsIds) && likedPostsIds.includes(post_id)){
                const ids = likedPostsIds.slice();
                likedPostsIds = ids.filter(liked_post_id => {
                    return liked_post_id !== post_id;
                });
            }
        }

        const updateLikes = (post_id, add) => {
            if(add){
                addLike(post_id);
            }else{
                removeLike(post_id);
            }
        }
        
        const onButtonClicked = ($self) => {
			$self.toggleClass('is--liked', !$self.hasClass('is--liked'));

			if($self.hasClass('is--liked')){				
				$self.addClass('is--animated');
				setTimeout(() => {
					$self.removeClass('is--animated');
				}, 300);
			}

            updateLike($self);
		}

        const setLikeButtonClass = ($self, post_id) => {
            $self.toggleClass('is--liked', Array.isArray(likedPostsIds) && likedPostsIds.includes(post_id));
        }

        const setLikeButtonNumber = ($self, likes) => {
            $self.find('.like-counter').text(likes);
        }

        /**
         * Update like buttons of same post id
         */
        const updateLikeButtons = ($self, post_id, result_likes) => {
            const $buttons = $('.fr-like-button[data-fr-post-id='+post_id+']').not($self);
            $buttons.each((i, el) => {
                $(el).frReInitializeLikeButton(likedPostsIds);
                $(el).find('.like-counter').text(result_likes);
            });
        }

        const updateLike = ($self) => {
            if(ajaxRunning && ajaxRunningPostId == $self.ajaxConfig.post_id) return;

            requestCounter++;

            const ajaxConfig = $self.ajaxConfig;
            const currentLikes = parseInt($self.find('.like-counter').text());
            
            ajaxConfig.add = !likedPostsIds.includes(ajaxConfig.post_id);

            $self.find('.like-counter').text(ajaxConfig.add ? currentLikes + 1 : currentLikes - 1);

            ajaxRunning = true;
            ajaxRunningPostId = ajaxConfig.post_id;

            $.frAjax({
                url: ajaxConfig.url,
                action: ajaxConfig.action,
                data: ajaxConfig,
            }).then(resData => {
                const result_likes = resData.likes;

                requestCounter--;

                updateLikes(ajaxConfig.post_id, ajaxConfig.add);

                setLikeButtonClass($self, ajaxConfig.post_id);

                setLikeButtonNumber($self, result_likes);

                updateLikeButtons($self, ajaxConfig.post_id, result_likes);
                
                ajaxRunning = false;

                if(requestCounter === 0){
                    // This is the last response
                    updateSessionStorage();
                }
            }).catch((err) => {
                console.log(err);

                setLikeButtonClass($self, ajaxConfig.post_id);

                setLikeButtonNumber($self, $self.initialLikes);

                ajaxRunning = false;

                requestCounter--;

                if (requestCounter === 0) {
                    // This is the last response
                    updateSessionStorage();
                }
            });
        }

		return this.each((i, el) => {
			const $self = $(el);
            const post_id = $self.attr('data-fr-post-id');
            let ajaxConfig = JSON.parse(($self.attr('ajax-config') ? $self.attr('ajax-config') : '{}'));

            ajaxConfig.post_id = post_id;
            $self.ajaxConfig = ajaxConfig;
            $self.initialLikes = parseInt($self.find('.like-counter').text());

            setLikeButtonClass($self, post_id);

			$self.on('click', (e) => {
				onButtonClicked($self);
			});
		});
	}

	$.fn.frReInitializeLikeButton = function () {
		this.each((i, el) => {
			const $self = $(el);
			$self.off('click');
		});

		this.frLikeButton();
	}

	$.initialize('.fr-like-button', function(){
		$(this).frLikeButton();
	});
})($);